export default __webpack_public_path__ + "static/media/kitchen3-afterC-2048w.f0464c71.webp";